module.exports = new __parcel__URL__("cog-illustration.58f1b3ca.png").toString();